import React, { useEffect, useState } from 'react';
import Container from '../../../Container/Container';
import { Image } from 'antd';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { get } from '../../../ApiServices/ApiServices';
import Loader from '../../Component/Loader';
import moment from 'moment';
import CancelFun from '../../Component/CancelFun';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { ImageUrl } from '../../../ApiServices/ApiServices';
import { BrideLogoIcon, GroomLogoIcon } from '../../Component/Svg';

function WeddingEventdetail() {
    const location = useLocation();

    const navigate = useNavigate();
    const { eventId } = location.state || {};

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [MemberData, setMemberData] = useState([]);
    const [count, setCount] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    const [showLoader, setShowLoader] = useState(true);




    useEffect(() => {
        localStorage.removeItem('coatStyle');
        localStorage.removeItem('size');
        localStorage.removeItem('nonBoldMessage');
        localStorage.removeItem('selectedCoatSize');
        localStorage.removeItem('selectedCategoryName');
        localStorage.removeItem('allSize');
        localStorage.removeItem('Shoes');
        localStorage.removeItem('savedInsleeve');
        localStorage.removeItem('pantSizeRecommendationMsg');
        localStorage.removeItem('pantstyle');
        localStorage.removeItem('selectedPantStyle');
        localStorage.removeItem('coatid');
        localStorage.removeItem('selectedCategoryId');


    }, [])
    useEffect(() => {
        // Always show loader for minimum 1.5 seconds
        const timer = setTimeout(() => {
            setShowLoader(false);
        }, 1000);

        // Clean up timer on unmount
        return () => clearTimeout(timer);
    }, [showLoader]);



    const profile = useSelector((state) => state.profile.profile);

    const getWeddingDetail = async () => {
        setLoading(true);
        try {
            const api = `view-wedding-event/${eventId}`;
            const response = await get(api);
            if (response?.status === true) {
                setData(response.data);
            }
        } catch (err) {
            console.error('Error fetching wedding orders:', err);
        } finally {
            setLoading(false);
        }
    };

    const getMember = async (page = 1, size = itemsPerPage, search = '') => {
        try {
            const api = `all-wedding-members-of-event/${eventId}?orderby=asc&page=${page}&size=${size}&search=${search}`;
            const response = await get(api);
            if (response?.status === true) {
                setMemberData(response?.data?.rows);
                setShowLoader(true)
                setCount(response?.data?.count);
            }
        } catch (err) {
            console.error('Error fetching wedding members:', err);
        }
    };



    const handleSearch = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        getMember(1, itemsPerPage, term);
        setCurrentPage(1);
    };

    // Handle page change
    const handlePageChange = (page) => {
        setCurrentPage(page);
        getMember(page, itemsPerPage, searchTerm);
    };

    // Handle items per page change
    const handleItemsPerPageChange = (e) => {
        const newSize = parseInt(e.target.value);
        setItemsPerPage(newSize);
        getMember(1, newSize, searchTerm);
        setCurrentPage(1);
    };


    useEffect(() => {
        if (eventId) {
            getWeddingDetail();
            getMember();
        } else {
            navigate('/weddings'); // ✅ Redirect if no eventId
        }
    }, [eventId]);

    const getGroomStyles = () => {
        if (!data?.wedding_style) return [];
        return data.wedding_style.filter(style => style.type === 'groom');
    };

    const getGroomsmenStyles = () => {
        if (!data?.wedding_style) return [];
        return data.wedding_style.filter(style => style.type === 'groomsman');
    };

    const getStyleAndDescription = (styles, category) => {
        const item = styles.find(s => s.inventory_category_type === category &&
            s.inventory_category?.inventories?.[0]);
        if (!item) return 'N/A';
        const inventory = item.inventory_category.inventories[0];
        const style = item.style;
        const description = inventory.description;
        return description ? `${style} - ${description}` : style;
    };

    const getStyleByCategory = (styles, category) => {
        const item = styles.find(style => style.inventory_category_type === category);
        return item ? item.style : '---';
    };

    const onCancleSuccess = () => {
        getMember();
    };

    if (loading) {
        return (
            <Container>
                <div className="nk-content">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            <div className="nk-content-body">
                                <Loader />
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        );
    }

    if (!data) {
        return (
            <Container>
                <div className="nk-content">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            <div className="nk-content-body">
                                <div className="alert alert-danger">Failed to load wedding event data</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        );
    }

    const groomStyles = getGroomStyles();
    const groomsmenStyles = getGroomsmenStyles();
    const coatItems = groomStyles?.filter(item => item.inventory_category_type === 'Coats') || [];
    const firstCoatImage = coatItems[0]?.inventory_category?.inventories?.[0]?.image;
    const totalPages = Math.ceil(count / itemsPerPage);


    return (
        <Container>
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">Wedding Event</h3>
                                    </div>


                                    <div className="nk-block-head-content">
                                        <div className="toggle-wrap nk-block-tools-toggle d-flex gap-2">
                                            <div className="toggle-expand-content">
                                                <button
                                                    onClick={() => navigate(-1)}
                                                    className="btn btn-outline-light"
                                                >
                                                    <em className="icon ni ni-arrow-left"></em> <span>Back</span>
                                                </button>
                                            </div>
                                            {/* Corrected conditional rendering */}
                                            {(data?.status_id == 4 || data?.user?.deletedAt) ? "" : (
                                                <div className="toggle-expand-content">
                                                    <button
                                                        onClick={() => navigate(`/add-member`, {
                                                            state: {
                                                                eventid: eventId,
                                                                Account: data?.account,
                                                                user_Id: data?.user_id,
                                                            }
                                                        })}
                                                        className="btn btn-primary"
                                                    >
                                                        <span>Add Member</span>
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card card-full">
                                <div className="card-inner">
                                    <div className="groomStyleBox">
                                        <div className="groomStyleBoxInner">
                                            <div className="leftImageGroom">
                                                {firstCoatImage ? (
                                                    <Image
                                                        src={`${ImageUrl}${firstCoatImage}`}
                                                        className="suitimg"
                                                        alt="Coat"
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = "/assets/images/no-photo.png";
                                                        }}
                                                    />
                                                ) : (
                                                    <img
                                                        src="/assets/images/no-photo.png"
                                                        className="selectCoatImg"
                                                        alt="No coat available"
                                                    />
                                                )}
                                                <div className="leftImageGroomInner">
                                                    <div className="GroomBrideName">
                                                        <div className="nameInnerBox">

                                                            <GroomLogoIcon />
                                                            <span>
                                                                Groom's Name <small>{data?.groom_first_name} {data?.groom_last_name}</small>
                                                            </span>
                                                        </div>
                                                        <div className="nameInnerBox">
                                                            <BrideLogoIcon />
                                                            <span>
                                                                Bride's Name <small>{data?.bride_first_name} {data?.bride_last_name}</small>
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <p className='mb-2 orderDateSec'>
                                                        <em className="icon ni ni-calender-date"></em>
                                                        Event date: {moment(data?.wedding_date).format("MMM D, YYYY")}

                                                    </p>
                                                    <p className='mb-2 orderDateSec mt-0'>
                                                        <em className="icon ni ni-call"></em>
                                                        Phone: {data?.groom_phone ? data?.groom_phone : "N/A"}
                                                    </p>
                                                    {/* <span className="orderDateTxtGroom">

                                                        Order date: {moment(data?.createdAt).format("MMM D, YYYY")}<br></br>
                                                        Phone: {data?.groom_phone ? data?.groom_phone : "N/A"}

                                                    </span> */}
                                                </div>
                                            </div>

                                            <div className="rightEditGroomBride">
                                                {
                                                    (data?.status_id == 4 || data?.user?.deletedAt) ? "" :
                                                        <div className="righteditBtnInner">
                                                            <button onClick={() => navigate(`/update-wedding-event`, { state: { eventId: data?.id } })} style={{ cursor: "pointer" }} className="AddEvent">Edit Event</button>
                                                            <button
                                                                onClick={() => navigate("/update-GroomMen-Style", {
                                                                    state: {
                                                                        data: data
                                                                    }
                                                                })}
                                                                style={{ cursor: "pointer" }}
                                                                className="editEvent"
                                                            >
                                                                Edit Styles
                                                            </button>
                                                        </div>
                                                }

                                                <p className='mb-2 orderDateSec' style={{ paddingLeft: "0px" }}>
                                                    <em className="icon ni ni-calender-date"></em>
                                                    Order date: {moment(data?.createdAt).format("MMM D, YYYY")}

                                                </p>

                                                {/* <span className="orderDateTxtGroom">
                                                    <em className="icon ni ni-calender-date"></em>
                                                    Event date: {moment(data?.wedding_date).format("MMM D, YYYY")}
                                                </span> */}
                                            </div>
                                        </div>

                                        {groomsmenStyles.length > 0 && (
                                            <div className="groomStyleSize">
                                                <h6>Groomsmen Styles</h6>
                                                <ul className="fstCategory">
                                                    <li><span>Coat:</span> {getStyleAndDescription(groomsmenStyles, 'Coats')}</li>
                                                    <li><span>Pant:</span> {getStyleAndDescription(groomsmenStyles, 'Pants')}</li>
                                                    <li><span>Vest:</span> {getStyleAndDescription(groomsmenStyles, 'Vests')}</li>
                                                </ul>
                                                <ul className="fstCategory">
                                                    <li><span>Shirt:</span> {getStyleAndDescription(groomsmenStyles, 'Shirt')}</li>
                                                    <li><span>Shoes:</span> {getStyleAndDescription(groomsmenStyles, 'Shoes')}</li>
                                                    <li><span>Tie:</span> {getStyleAndDescription(groomsmenStyles, 'Ties')}</li>
                                                </ul>
                                            </div>
                                        )}
                                    </div>

                                    <div className="card-title-group mb-3">
                                        <div className="card-tools">
                                            <div className="form-control-wrap">
                                                <h5 className="mb-0">Event Members</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-tools weddingEveSearch" style={{ flex: '1 0 -1px' }}>
                                        <div className="form-control-wrap">
                                            <div className="form-icon form-icon-right">
                                                <em className="icon ni ni-search"></em>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search by name, account, or ticket"
                                                value={searchTerm}
                                                onChange={handleSearch}
                                                style={{
                                                    minWidth: '100%',
                                                    border: '1px solid #dbdfea',
                                                    color: '#35495e',
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        {showLoader ? (
                                            <div className="text-center my-5">
                                                <Loader /> {/* Your existing loader component */}
                                            </div>
                                        ) : MemberData && MemberData.length > 0 ? (
                                            <div className="table-responsive">
                                                <table className="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Acct</th>
                                                            <th scope="col">Ticket</th>
                                                            <th scope="col">Order Status</th>
                                                            <th scope="col">Name</th>
                                                            <th scope="col">Role</th>
                                                            <th scope="col">Coat</th>
                                                            <th scope="col">Pant</th>
                                                            <th scope="col">Shirt</th>
                                                            <th scope="col">Vest</th>
                                                            <th scope="col">Tie</th>
                                                            <th scope="col">Shoe</th>
                                                            <th scope="col">Pocket Square</th>
                                                            <th scope="col">Jewelry</th>
                                                            <th scope="col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {MemberData.map((member, index) => {
                                                            const coatItem = member.wedding_style?.find(item => item.inventory_category?.name === "Coats");
                                                            const shirtItem = member.wedding_style?.find(item => item.inventory_category?.name === "Shirt");
                                                            const pantsItem = member.wedding_style?.find(item => item.inventory_category?.name === "Pants");
                                                            const tieItem = member.wedding_style?.find(item => item.inventory_category?.name === "Ties");
                                                            const jewelryItem = member.wedding_style?.find(item => item.inventory_category?.name === "Jewelry");
                                                            const vestItem = member.wedding_style?.find(item => item.inventory_category?.name === "Vests");
                                                            const shoeItem = member.wedding_style?.find(item => item.inventory_category?.name === "Shoes");
                                                            const pocketSquareItem = member.wedding_style?.find(item => item.inventory_category?.name === "PocketSquare");

                                                            // Check if sizes are missing
                                                            const isCoatSizeMissing = coatItem && (!coatItem?.size);
                                                            const isPantsSizeMissing = pantsItem && (!pantsItem?.size, !pantsItem?.outseam);
                                                            const isShirtSizeMissing = shirtItem && (!shirtItem?.shirt_size);
                                                            const isVestSizeMissing = vestItem && (!vestItem?.size);
                                                            const isTieSizeMissing = tieItem && (!member?.order_for);
                                                            const isShoeSizeMissing = shoeItem && (!shoeItem?.size);

                                                            return (
                                                                <tr key={index}>
                                                                    <td>{member.user?.account || "__"}</td>
                                                                    <td>{member.ticket || "__"}</td>
                                                                    <td style={{ textTransform: 'capitalize' }}>{member?.status?.name}</td>
                                                                    <td className="tableMinWidth">{(member.first_name || "__") + " " + (member.last_name || "")}</td>
                                                                    <td className="tableMinWidth">{member.wedding_role?.name || "__"}</td>

                                                                    {/* Coat Column */}
                                                                    <td className={isCoatSizeMissing && member?.status?.name != "cancelled" ? "redBgAlert" : ""}

                                                                        data-tooltip-id={`coat-tooltip-${index}`}
                                                                        data-tooltip-content={coatItem?.inventory?.description && `${coatItem?.inventory?.description || ''} , ${coatItem?.size || "Missing size"}${coatItem?.size && coatItem?.size_chart_category?.name
                                                                            ? coatItem.size_chart_category.name === "Short"
                                                                                ? "S"
                                                                                : coatItem.size_chart_category.name === "Long"
                                                                                    ? "L"
                                                                                    : coatItem.size_chart_category.name === "Extra Long"
                                                                                        ? "X"
                                                                                        : coatItem.size_chart_category.name === "Regular"
                                                                                            ? "R"
                                                                                            : coatItem.size_chart_category.name === "Boys"
                                                                                                ? "B"
                                                                                                : ""
                                                                            : ""}`}
                                                                    >
                                                                        {coatItem?.style || "---"}
                                                                        <ReactTooltip id={`coat-tooltip-${index}`} />
                                                                    </td>

                                                                    {/* Pants Column */}
                                                                    <td className={isPantsSizeMissing && member?.status?.name != "cancelled" ? "redBgAlert" : ""}

                                                                        data-tooltip-id={`pants-tooltip-${index}`}
                                                                        data-tooltip-content={pantsItem?.inventory?.description && `${pantsItem?.inventory?.description || ''} , ${pantsItem?.size || "Missing size"}, ${pantsItem?.outseam || "Missing outseam"}`}
                                                                    >
                                                                        {pantsItem?.style || "---"}
                                                                        <ReactTooltip id={`pants-tooltip-${index}`} />
                                                                    </td>

                                                                    {/* Shirt Column */}
                                                                    <td className={isShirtSizeMissing && member?.status?.name != "cancelled" ? "redBgAlert" : ""}

                                                                        data-tooltip-id={`shirt-tooltip-${index}`}
                                                                        data-tooltip-content={shirtItem?.inventory?.description && `${shirtItem?.inventory?.description || ''} , ${shirtItem?.shirt_size || "Missing size"}`}
                                                                    >
                                                                        {shirtItem?.style || "---"}
                                                                        <ReactTooltip id={`shirt-tooltip-${index}`} />
                                                                    </td>

                                                                    {/* Vest Column */}
                                                                    <td className={isVestSizeMissing && member?.status?.name != "cancelled" ? "redBgAlert" : ""}
                                                                        // style={{
                                                                        //     background: isVestSizeMissing ? "red" : "transparent",   
                                                                        //     cursor: "pointer"
                                                                        // }}
                                                                        data-tooltip-id={`vest-tooltip-${index}`}
                                                                        data-tooltip-content={vestItem?.inventory?.description && `${vestItem?.inventory?.description || ''} , ${vestItem?.size || "Missing size"}`}
                                                                    >
                                                                        {vestItem?.style || "---"}
                                                                        <ReactTooltip id={`vest-tooltip-${index}`} />
                                                                    </td>

                                                                    {/* Tie Column */}
                                                                    <td className={isTieSizeMissing && member?.status?.name != "cancelled" ? "redBgAlert" : ""}

                                                                        data-tooltip-id={`tie-tooltip-${index}`}
                                                                        data-tooltip-content={tieItem?.inventory?.description && `${tieItem?.inventory?.description || ''} , ${member?.order_for || 'Missing size'} `}
                                                                    >
                                                                        {tieItem?.style || "---"}
                                                                        <ReactTooltip id={`tie-tooltip-${index}`} />
                                                                    </td>

                                                                    {/* Shoe Column */}
                                                                    <td className={isShoeSizeMissing && member?.status?.name != "cancelled" ? "redBgAlert" : ""}
                                                                        data-tooltip-id={`shoe-tooltip-${index}`}
                                                                        data-tooltip-content={shoeItem?.inventory?.description && `${shoeItem?.inventory?.description || ''}, ${shoeItem?.inventory?.description ? shoeItem?.size || 'Missing size' : ''}`}
                                                                    >
                                                                        {shoeItem?.style || "---"}
                                                                        <ReactTooltip id={`shoe-tooltip-${index}`} />
                                                                    </td>

                                                                    {/* Pocket Square Column - No size needed */}
                                                                    <td
                                                                        data-tooltip-id={`pocket-square-tooltip-${index}`}
                                                                        data-tooltip-content={pocketSquareItem?.inventory?.description || ''}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        {pocketSquareItem?.style || "---"}
                                                                        <ReactTooltip id={`pocket-square-tooltip-${index}`} />
                                                                    </td>

                                                                    {/* Jewelry Column - No size needed */}
                                                                    <td
                                                                        data-tooltip-id={`jewelry-tooltip-${index}`}
                                                                        data-tooltip-content={jewelryItem?.inventory?.description || ''}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        {jewelryItem?.style || "---"}
                                                                        <ReactTooltip id={`jewelry-tooltip-${index}`} />
                                                                    </td>

                                                                    <td className="tableActionBtn" style={{ cursor: "pointer" }}>
                                                                        <button
                                                                            className="editPen"
                                                                            style={member?.status?.name == 'cancelled' || member?.status?.name == 'pendingCancel' || member?.status?.name == "pendingChange" || member?.status?.name == "cancelRequested" || member?.status?.name == "shipped" || member?.status?.name == "printed" || member?.status?.name == "bagged" || member?.user?.deletedAt
                                                                                ? { opacity: 0.5, cursor: 'not-allowed' }
                                                                                : {}}
                                                                            onClick={(member?.status?.name == 'cancelled' || member?.status?.name == 'pendingCancel' || member?.status?.name == "pendingChange" || member?.status?.name == "cancelRequested" || member?.status?.name == "shipped" || member?.status?.name == "printed" || member?.status?.name == "bagged" || member?.user?.deletedAt) ? undefined : () => {
                                                                                navigate('/update-member', {
                                                                                    state: { memberId: member?.id }
                                                                                });
                                                                            }}
                                                                        >
                                                                            <em className="icon ni ni-edit-alt"></em>
                                                                        </button>
                                                                        <button style={{ cursor: "pointer" }} onClick={() => navigate(`/Member-detail`, { state: { eventId: member?.id } })} className="deleteTrash">
                                                                            <em className="icon ni ni-eye"></em>
                                                                        </button>
                                                                        {(member?.status?.name == 'cancelled' || member?.status?.name == 'pendingCancel' || member?.status?.name == "pendingChange" || member?.status?.name == "cancelRequested" || member?.status?.name == "shipped" || member?.status?.name == "printed" || member?.status?.name == "bagged" || member?.user?.deletedAt) ? "" : (
                                                                            <CancelFun
                                                                                url={`change-wedding-member-status/${member.id}`}
                                                                                onCancleSuccess={onCancleSuccess}
                                                                                status={member?.status?.name == "ordered" ? 11 : null}

                                                                            />
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <div className="text-center my-5">
                                                <p className="text-muted">No data found</p>
                                            </div>
                                        )}
                                    </div>
                                    {
                                        count != 0 &&
                                        <div className="nk-block-between-md g-3 mt-3">
                                            <div className="g">
                                                <div className="pagination d-flex gap-2" style={{ height: "35px" }}>
                                                    <button
                                                        className={`btn btn-sm ${currentPage === 1 ? 'btn-disabled' : 'btn-primary'}`}
                                                        onClick={() => handlePageChange(currentPage - 1)}
                                                        disabled={currentPage === 1}
                                                    >
                                                        Previous
                                                    </button>

                                                    {Array.from({ length: totalPages }, (_, i) => (
                                                        <button
                                                            key={i + 1}
                                                            className={`btn btn-sm ${currentPage === i + 1 ? 'btn-primary' : 'btn-outline-primary'}`}
                                                            onClick={() => handlePageChange(i + 1)}
                                                        >
                                                            {i + 1}
                                                        </button>
                                                    )).slice(
                                                        Math.max(0, currentPage - 3),
                                                        Math.min(currentPage + 2, totalPages)
                                                    )}

                                                    <button
                                                        className={`btn btn-sm ${currentPage === totalPages ? 'btn-disabled' : 'btn-primary'}`}
                                                        onClick={() => handlePageChange(currentPage + 1)}
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        Next
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Container >
    );
}

export default WeddingEventdetail;